import Cookies from 'js-cookie'

const User = 'userInfo'

export function getUser(){
    return Cookies.get(User)
}

export function setUser(data){
    return Cookies.set(User, data)
}

export function removeUser(){
    return Cookies.remove(User)
}


// WEBPACK FOOTER //
// ./src/utils/auth.js